import React from 'react'

import {
  InnerWidgetPatchBody,
  TViewport,
  TWidgetSettings,
  WidgetType
} from 'types/GlobalWidget'

import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import { useTranslation } from 'language/translator'

interface ViewportSectionProps {
  settings: TWidgetSettings
  setViewport: (value: TViewport) => void
  updateWidget: (body: InnerWidgetPatchBody) => void
  viewport: TViewport
}

const LEGAL_TYPES = [WidgetType.MAP]

const ViewportSection = (props: ViewportSectionProps) => {
  const { settings, updateWidget, viewport } = props
  const { t } = useTranslation()

  if (!LEGAL_TYPES.includes(settings.type.selected)) {
    return null
  }

  return (
    <SettingsGroup
      helperText={t('widgets', 'viewport_helper_text')}
      title={t('widgets', 'camera')}
    >
      <SettingsItem
        title={t('widgets', 'longitude')}
        value={viewport.longitude}
      />
      <SettingsItem
        title={t('widgets', 'latitude')}
        value={viewport.latitude}
      />
      <SettingsItem title={t('widgets', 'zoom')} value={viewport.zoom} />
      <SettingsItem
        disabled={
          viewport.longitude === settings.viewport.longitude &&
          viewport.latitude === settings.viewport.latitude &&
          viewport.zoom === settings.viewport.zoom
        }
        onClick={() => {
          updateWidget({
            latitude: viewport.latitude,
            longitude: viewport.longitude,
            zoom: viewport.zoom
          })
        }}
        title={t('global', 'save')}
        variant="action"
      />
    </SettingsGroup>
  )
}

export default ViewportSection
